import { Icon } from "@chakra-ui/icons";

interface Props {
  color?: string;
  boxSize?: string;
}
export const Discord = (props: Props) => (
  <Icon viewBox="0 0 37 24" {...props}>
    <path
      d="M19.9999 12C19.9999 9.23859 22.2385 7 24.9999 7C25.7704 7 26.4915 7.18872 27.1434 7.5H36.1195C34.3385 3.104 30.0347 0 24.9999 0C21.1478 0 17.7286 1.82233 15.533 4.64392L20.0424 12.4211C20.0304 12.28 19.9999 12.1442 19.9999 12Z"
      fill="#F44336"
    />
    <path
      d="M25 17.0001C22.3828 17.0001 20.2596 14.9822 20.0424 12.4212L15.533 4.64404C13.9512 6.67682 13 9.22485 13 12.0001C13 18.0726 17.5149 23.0786 23.3684 23.8764L27.8195 16.1264C27.0164 16.6762 26.0467 17.0001 25 17.0001Z"
      fill="#00B060"
    />
    <path
      d="M27.1434 7.5C28.8276 8.30438 30 10.0091 30 12C30 13.7147 29.135 15.2255 27.8195 16.1263L23.3684 23.8763C23.9033 23.9492 24.4451 24 25 24C31.6274 24 37 18.6274 37 12C37 10.4073 36.6829 8.89056 36.1196 7.5H27.1434Z"
      fill="#FFC107"
    />
    <path
      d="M25 16C27.2091 16 29 14.2091 29 12C29 9.79086 27.2091 8 25 8C22.7909 8 21 9.79086 21 12C21 14.2091 22.7909 16 25 16Z"
      fill="#2196F3"
    />
    <path
      d="M29.4559 9.76105L36.1196 7.5H27.1434C28.1434 7.97754 28.955 8.77728 29.4559 9.76105Z"
      fill="url(#paint0_linear_3176_91786)"
    />
    <path
      d="M20.8331 9.26052L15.5431 4.62012L20.0312 12.3937C19.9447 11.2889 20.2315 10.1862 20.8331 9.26052Z"
      fill="url(#paint1_linear_3176_91786)"
    />
    <path
      d="M24.711 16.9786L23.3373 23.88L27.8253 16.1064C26.9118 16.7336 25.8134 17.0367 24.711 16.9786Z"
      fill="url(#paint2_linear_3176_91786)"
    />
    <path
      d="M36.5 12C36.5 18.3513 31.3513 23.5 25 23.5C18.6487 23.5 13.5 18.3513 13.5 12C13.5 5.64873 18.6487 0.5 25 0.5C31.3513 0.5 36.5 5.64873 36.5 12Z"
      fill="url(#paint3_linear_3176_91786)"
      stroke="white"
    />
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="url(#paint4_radial_3176_91786)"
    />
    <path
      d="M11.9999 23.7291C18.5526 23.7291 23.8645 18.4172 23.8645 11.8646C23.8645 5.31195 18.5526 0 11.9999 0C5.44732 0 0.135376 5.31195 0.135376 11.8646C0.135376 18.4172 5.44732 23.7291 11.9999 23.7291Z"
      fill="url(#paint5_linear_3176_91786)"
    />
    <path
      opacity="0.1"
      d="M20.6663 6.88306L20.184 6.79852L20.556 6.20673C20.5546 6.20367 19.7963 6.68567 19.7949 6.68268C19.6628 6.38971 19.3162 6.51752 19.0873 6.36853C19.1566 6.25995 19.1843 6.14648 19.2283 6.06134C19.2954 5.93195 19.5302 5.72156 19.4904 5.60333L19.5404 5.30695L19.623 5.12708L19.1171 5.09131L18.8377 5.03296L18.5005 4.89941L18.4489 5.50061L18.3192 5.63C18.3165 5.62799 18.3131 5.62482 18.3105 5.62286C18.0172 5.40515 17.8897 4.84918 17.5299 4.97784C17.1701 5.10651 17.0314 4.77869 16.5732 4.98688C16.1151 5.19501 16.2177 5.05786 16.0372 5.27429C15.8567 5.49066 15.9072 5.83801 15.8787 6.05719C15.8532 6.25275 15.7104 6.53394 15.7405 6.74951C15.7119 6.74237 15.6848 6.73816 15.6544 6.72668C15.4312 6.64197 15.5396 6.42322 15.2927 6.33423C15.141 6.27948 15.1448 6.5224 15.2003 6.78302C15.1929 6.78967 15.0559 6.91144 14.8262 6.94531C14.5901 6.9801 14.5782 6.73627 14.3192 6.77875C14.0602 6.82117 14.5433 7.35162 14.7951 7.534C15.0469 7.71631 15.1126 8.17712 15.4591 8.07355C15.6078 8.02905 15.7108 8.05408 15.815 8.08356C16.008 8.19794 16.0501 8.39673 16.4343 8.45361C16.6289 8.48242 16.7158 8.50647 16.7706 8.52112L16.7865 8.54327L17.0145 9.02069L17.27 8.33783C17.3001 8.30701 17.3204 8.27924 17.3472 8.24683C17.4515 8.67645 17.5866 9.22864 17.5833 9.229C17.0414 9.2832 17.0598 9.90894 16.6971 10.1964C16.56 10.0265 16.3927 9.9209 16.2797 9.80414C16.108 9.62671 15.8966 9.13617 15.6852 9.13617L15.2361 8.89612L14.9917 8.6665L14.6614 9.45972L14.4171 9.8772L14.0208 10.3469L14.9587 10.7539L15.0966 11.032C15.0919 11.0353 15.085 11.039 15.0805 11.0422C14.5726 11.3959 13.6107 11.301 13.6234 11.9483C13.6361 12.5957 13.0347 12.6417 13.1221 13.4899C13.2094 14.3381 13.0444 14.0994 13.2947 14.506C13.5451 14.9126 14.1301 15.0189 14.4669 15.1828C14.7673 15.3291 15.142 15.7102 15.5046 15.778C15.4776 15.8201 15.4563 15.8615 15.4214 15.9041C15.165 16.2169 14.8721 15.9249 14.596 16.2735C14.4262 16.4876 14.8185 16.6125 15.267 16.6639C15.2738 16.6794 15.3956 16.965 15.3261 17.3523C15.2546 17.7504 14.8566 17.6381 14.7852 18.077C14.7137 18.5159 15.8262 18.0259 16.255 17.7197C16.6836 17.4135 17.4593 17.5564 17.4797 16.944C17.4885 16.6812 17.5842 16.5292 17.6877 16.3776C17.9755 16.1293 18.3176 16.1688 18.6161 15.5823C18.7673 15.2852 18.8528 15.1586 18.9058 15.0785L18.95 15.0649L19.8399 14.9562L18.8807 14.1775C18.7749 13.9713 18.6327 13.7879 18.549 13.6282C18.4664 13.4706 18.4103 13.2243 18.3298 13.0062C18.4539 12.9807 18.573 12.9066 18.6854 12.7148C19.002 12.1743 19.2839 12.3196 19.6683 11.5898C20.0526 10.8601 20.0049 11.1083 20.0993 10.6949C20.1937 10.2816 19.9945 10.0151 19.9309 9.77643C19.8674 9.53784 19.9218 9.00647 19.7371 8.9035L19.4618 8.4751L19.4906 8.34882C19.7026 8.30804 19.817 8.17328 19.9295 8.09894C20.0511 8.01855 20.3586 7.94922 20.3815 7.8266L20.5695 7.5921L20.7805 7.57098L20.7875 7.24438L20.8958 6.94867L20.6663 6.88306ZM17.4941 8.07373C17.5004 8.06665 17.5087 8.0556 17.515 8.04907C17.5877 7.97327 17.715 7.89569 17.8219 7.80969C17.8594 7.87433 17.9232 7.927 18.0516 7.95386C18.1699 7.97858 18.2438 8.0163 18.3101 8.05682L17.9791 8.6665L17.4941 8.07373Z"
      fill="black"
    />
    <path
      d="M24 11.9793C24 18.6053 18.6261 24.0001 12 24.0001C5.37394 24.0001 0 18.6053 0 11.9793C0 9.85052 0.563455 7.84706 1.53388 6.11492C0.918266 5.23837 0.699113 3.50622 2.08696 2.06622C2.08696 2.61923 2.42088 3.56883 2.79651 4.27838C3.0991 4.84184 3.42296 5.2502 3.65217 5.19665C4.17466 5.07459 6 5.07144 6.26087 5.19665C6.68867 4.64358 7.73215 3.10969 9.3913 3.10969C8.46259 4.0384 5.80174 7.28361 10.4348 7.28361C10.9565 7.28361 11.4783 7.28361 11.4783 7.28361L8.34783 9.37056C8.34783 9.37056 8.70264 10.0592 8.34783 10.414C7.9513 10.0175 6.26087 10.8418 6.26087 11.9793C6.26087 13.1166 7.47128 14.588 9.91304 14.588C12.3548 14.588 11.7391 13.5445 13.0435 13.5445C14.3478 13.5445 14.6087 14.588 14.6087 14.588C12.8139 14.588 11.5096 16.6749 9.3913 16.6749C10.4348 17.4471 11.1235 17.7184 12.5217 17.7184C15.9756 17.7184 18.7826 14.9114 18.7826 11.4575C18.7826 10.0592 18.3235 8.77577 17.5513 7.7323C18.9495 8.77577 19.8887 10.3827 20.0556 12.2088C20.2435 11.4783 20.3478 10.6957 20.3478 9.8923C20.3478 6.76187 19.0956 2.56706 16.7896 0.980957C21.0365 2.82793 24 7.05401 24 11.9793Z"
      fill="url(#paint6_radial_3176_91786)"
    />
    <path
      opacity="0.1"
      d="M6.26086 11.9792C6.26086 10.8418 7.95129 10.0175 8.34784 10.414C8.63843 10.1234 8.45483 9.61469 8.37817 9.43799C8.35803 9.54572 8.31586 9.64886 8.23175 9.73297C7.82263 9.32385 6.07849 10.1743 6.07849 11.3479C6.07849 11.6219 6.15332 11.9145 6.28973 12.2023C6.27997 12.1278 6.26086 12.0516 6.26086 11.9792Z"
      fill="black"
    />
    <path
      d="M20.3478 9.89227C20.3478 10.3303 20.2548 11.5758 20.0588 12.208C20.0796 12.3425 20.1052 12.4755 20.1177 12.6125C20.3116 11.8588 20.613 10.0236 20.613 9.19464C20.613 6.92841 19.9747 4.12482 18.7733 2.08636C18.1505 1.66016 17.4896 1.2854 16.7896 0.980957C19.0956 2.56702 20.3478 6.76184 20.3478 9.89227Z"
      fill="url(#paint7_linear_3176_91786)"
    />
    <path
      d="M17.5513 7.73242C18.3234 8.77588 18.7825 10.0593 18.7825 11.4576C18.7825 12.0748 18.6895 12.6699 18.5225 13.2333C18.8268 12.4842 18.9981 11.6672 18.9981 10.8097C18.9981 10.1183 18.8834 9.45667 18.6824 8.83392C18.3514 8.42303 17.9756 8.04913 17.5513 7.73242Z"
      fill="url(#paint8_linear_3176_91786)"
    />
    <path
      opacity="0.1"
      d="M14.6087 14.588C14.6087 14.588 14.5443 14.3417 14.3321 14.0889C12.6613 14.3392 10.8178 16.2578 8.77808 16.2578C8.99701 16.4199 9.19916 16.5553 9.39703 16.6766C11.2206 16.7619 12.9724 14.588 14.6087 14.588Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M2.20233 2.75378C2.13599 2.4975 2.08704 2.25494 2.08704 2.06592C2.04907 2.10535 2.0246 2.14685 1.98901 2.18671C2.05048 2.37421 2.12384 2.56531 2.20233 2.75378Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M1.17719 5.34692C1.1861 5.33081 1.19226 5.31293 1.20129 5.29688C1.17969 5.26605 1.16296 5.22662 1.14233 5.19385C1.1543 5.24493 1.16284 5.29767 1.17719 5.34692Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M12 23.729C8.16507 23.729 4.69867 21.9761 2.42737 19.2373C4.62012 22.1097 8.10843 23.9999 12 23.9999C15.8916 23.9999 19.3543 22.1458 21.5471 19.2734C19.2758 22.0122 15.835 23.729 12 23.729Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M10.3002 7.27734L8.23169 8.65637C8.23169 8.65637 8.40839 9.00751 8.38855 9.34344L11.4782 7.28363C11.4782 7.28363 10.9565 7.28363 10.4347 7.28363C10.3851 7.28363 10.3481 7.27808 10.3002 7.27734Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M7.81882 6.18348C7.66125 4.96452 8.90563 3.59503 9.39128 3.10938C9.01738 3.10938 8.67925 3.19489 8.36791 3.3219C7.83489 4.0882 7.42307 5.52778 7.81882 6.18348Z"
      fill="black"
    />
    <path
      d="M16.6973 1.52533L16.7153 1.49466C20.7191 3.2931 23.5 7.30843 23.5 11.9791C23.5 18.3302 18.3488 23.5 12 23.5C5.65124 23.5 0.5 18.3302 0.5 11.9791C0.5 9.93952 1.03975 8.01979 1.97009 6.35912L2.1238 6.08474L1.94304 5.82738C1.5656 5.28996 1.34952 4.29194 1.83142 3.28628C1.97009 3.70318 2.15623 4.13742 2.3546 4.51218L2.35459 4.51218L2.35586 4.51455C2.36889 4.53885 2.38132 4.55902 2.38732 4.56877L2.38781 4.56957C2.39167 4.57584 2.39323 4.57841 2.39367 4.57913L2.74907 5.22306L3.217 4.65381C5.3022 2.11709 8.46176 0.5 12 0.5C13.6761 0.5 15.2627 0.872386 16.6973 1.52533Z"
      fill="url(#paint9_linear_3176_91786)"
      stroke="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3176_91786"
        x1="29.3875"
        y1="5.25597"
        x2="33.8755"
        y2="9.74403"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3176_91786"
        x1="14.8841"
        y1="5.2791"
        x2="21.0149"
        y2="11.4099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3176_91786"
        x1="23.6388"
        y1="18.0507"
        x2="26.4027"
        y2="20.8146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3176_91786"
        x1="14.1217"
        y1="6.92737"
        x2="35.8783"
        y2="17.0726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.2" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint4_radial_3176_91786"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.4375 -0.562501) scale(21.0836)"
      >
        <stop stopColor="#15BEF0" />
        <stop offset="0.268032" stopColor="#0D91CE" />
        <stop offset="0.530391" stopColor="#066DB1" />
        <stop offset="0.742498" stopColor="#0257A0" />
        <stop offset="0.877771" stopColor="#004E9A" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_3176_91786"
        x1="11.9999"
        y1="0"
        x2="11.9999"
        y2="23.7291"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" stopOpacity="0.4" />
      </linearGradient>
      <radialGradient
        id="paint6_radial_3176_91786"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.625 5.44167) rotate(141.761) scale(16.6495 17.0195)"
      >
        <stop stopColor="#FFF203" />
        <stop offset="0.298428" stopColor="#FBC40D" />
        <stop offset="0.776505" stopColor="#F47E1C" />
        <stop offset="1" stopColor="#F26322" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_3176_91786"
        x1="14.86"
        y1="5.11892"
        x2="22.0489"
        y2="8.47115"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3176_91786"
        x1="16.5845"
        y1="9.80562"
        x2="19.4893"
        y2="11.1601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3176_91786"
        x1="-0.14026"
        y1="6.33005"
        x2="22.8747"
        y2="17.0621"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.2" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </Icon>
);

export default Discord;
